import React from 'react'
import Career from './components/Career/Career'
export default class App extends React.Component {
    render() {
        // isApp checks the redirecting logic for widget
        return <Career />
    }
}
